import { ContentPage } from '../components/content-page';
import { ModuleManagementDataContext, ModuleManagementDataProvider } from '../providers/module-management-provider';
import { useContext } from 'react';
import { SelectedDetailsHeading } from '../components/selected-details-heading';
import { ModuleList } from '../components/admin-modules/module-list';
import ModuleManagementPage from '../components/admin-modules/module-management';
import { useLocation } from 'react-router-dom';

export default function AdminModulePage() {
    const { search } = useLocation();
     return (
        <ModuleManagementDataProvider>
            <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: '0'/*, backgroundColor: 'blue'*/ }}>
                <ContentPage
                    pageId="modules"
                    pageTitle="Module management"
                    leftPanelTitle="Modules"
                    rightPanelTitle="Selected module(s) details"
                    rightPanelHeading={<ModuleDetailsHeading />}
                    mobileTabs
                    mobileBackLabel="Back to modules"
                    mobileRightPanelTitle="Details"
                    initialMobilePanel={new URLSearchParams(search).has('module') ? 'right' : 'left'}
                    leftContent={<ModuleList fetchAll={false} />}
                    rightContent={<ModuleManagementPage />}
                />
            </div>
        </ModuleManagementDataProvider>
        );
}

function ModuleDetailsHeading() {
    const ctx = useContext(ModuleManagementDataContext)!;
    if (ctx.mode === 'create') return <SelectedDetailsHeading label="New module" />;
    const names = ctx.selectedModules.map(module => ctx.selectedModules.length === 1
        && ctx.selectedModuleFull?.module_key === module.module_key ? ctx.selectedModuleFull.name : module.name);
    return <SelectedDetailsHeading label="Module details" names={names} />;
}
